import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { prettyCalendarUrl, prettyStandingsUrl } from '../../../common/rcs_gaz_mc_core_FE';
import ConfigManager from '../../../common/configManager/configManager';
import MatchRowDashed from '../../../components/MatchRowDashed/index';
import Label from '../../../components/shared/Label/index';
import StandingButton from '../../../components/shared/StandingButton/index';
import * as types from '../../../constants/index';
import { ButtonsWrapper, DayStripWidgetWrapper, TitleWrapper } from './styles';
import HeaderTable from '../../../components/HeaderTable';

class DayWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      calendar: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    if (!this.props.day) {
      const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
      this.eventTimer = setInterval(this.getCalendar, interval);
    }
    this.getCalendar();
    this.resizeCallback();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.calendars && nextProps.widgetId && nextProps.calendars.get(nextProps.widgetId)) {
      const cal = nextProps.calendars.get(nextProps.widgetId);
      if (cal.get('status') && (cal.get('status') === 'FULL' || cal.get('status') === 'PREMATCH') && !this.props.day) {
        clearInterval(this.eventTimer);
      }
      this.setState({ calendar: cal });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.eventTimer) {
      clearInterval(this.eventTimer);
    }
  }

  getCalendar = () => {
    const {
      competitionId, sportId, actions, widgetId, day,
    } = this.props;
    if (day) {
      actions.getDayCalendar(sportId, competitionId, widgetId, day);
    } else {
      actions.getCalendar(sportId, competitionId, widgetId);
    }
  };

  getGazzanetDomain = (url) => {
    let returnedDomain = 'gazzetta';
    if (url && url.hostname) {
      const site = url.hostname;
      const [, domain] = site.split('.');
      returnedDomain = domain;
    }
    return returnedDomain;
  };

  getKeys = (matches) => {
    let matchKeys = [];
    [...matchKeys] = matches.keys();
    return matchKeys;
  };

  formatDate = (date) => {
    const options = {
      weekday: 'long', day: '2-digit', month: 'long', timeZone: 'UTC',
    };
    return new Date(date).toLocaleString('it-IT', options);
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  render() {
    const {
      dictionary, competitionId, sportId, day,
    } = this.props;
    const { isMobile, calendar } = this.state;
    let showDay = (calendar && calendar.get('currentDay')) ? calendar.get('currentDay') : '';
    if (day) {
      showDay = day;
    }
    const lastSubPhase = (calendar && calendar.get('lastSubPhase')) ? calendar.get('lastSubPhase') : '';
    return (
      <DayStripWidgetWrapper
        isMobile={isMobile}
      >
        {calendar &&
        <TitleWrapper className="has-background-primary">
          <Label
            label={`${dictionary.competitionTable.competitionName[competitionId]} - ${lastSubPhase || showDay}${dictionary.competitionTable.dayA}`}
            weight="bold"
            margin="0 0 16px 10px"
            size={0.9}
            isCapitalize
            color="white"
            isTitleNarrowMedium
          />
        </TitleWrapper>
        }
        {competitionId === '6' || competitionId === '941' || competitionId === '5' ?
          <React.Fragment>
            {calendar && calendar.get('games') && calendar.get('games').map((date, key) => (
              <React.Fragment key={key}>
                <HeaderTable
                  height="30px"
                  margin={key === 0 ? '0px' : '20px 0px 5px 0px'}
                  size={0.9}
                  bgColor="mainColorDark"
                  title={this.formatDate(date.get('date'))}
                />
                {this.getKeys(date.getIn(['matches', 0])).map((matches, matchesKey) => (
                  <React.Fragment key={matchesKey}>
                    <Label
                      label={`Gruppo ${matches}`}
                      margin="15px 10px 15px 10px"
                      block
                      size={0.9}
                    />
                    {date.getIn(['matches', 0, matches]).map((singleMatches, singleMatchesKey) => (
                      <MatchRowDashed
                        matchRow={singleMatches}
                        key={singleMatchesKey}
                        dictionary={dictionary}
                        competitionId={competitionId}
                        isGazzanetWidget
                      />
                    ))
                    }
                  </React.Fragment>
                ))
                }
              </React.Fragment>
            ))
            }
          </React.Fragment>
          :
          <React.Fragment>
            {calendar && calendar.get('games') && calendar.get('games').map(d => (
              d && d.get('matches') && d.get('matches').map((match, index) => (
                <MatchRowDashed
                  matchRow={match}
                  key={index}
                  dictionary={dictionary}
                  competitionId={competitionId}
                  isGazzanetWidget
                />
              ))
            ))
            }
          </React.Fragment>
        }
        {/*(window.location.hostname === 'www.fcinter1908.it' || window.location.hostname === 'dv1.calcionapoli1926.it' || window.location.hostname === 'www.calcionapoli1926.it' || window.location.hostname === 'www.forzaroma.info') &&
          <ButtonsWrapper>
            <StandingButton
              color="buttonColor"
              background="transparent"
              label="Classifica"
              borderColor="gray"
              linkTo={prettyStandingsUrl(sportId, competitionId, this.getGazzanetDomain(window.location))}
              width="35%"
              margin="15px 0px 25px 0px"
              size="16px"
              isTitleNarrowMedium
            />
            <StandingButton
              color="buttonColor"
              background="transparent"
              label="Calendario e risultati"
              borderColor="gray"
              linkTo={prettyCalendarUrl(sportId, competitionId, this.getGazzanetDomain(window.location))}
              width="60%"
              margin="15px 0px 25px 0px"
              size="16px"
              isTitleNarrowMedium
            />
          </ButtonsWrapper>
      */}
      </DayStripWidgetWrapper>
    );
  }
}

DayWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  calendars: PropTypes.any,
  widgetId: PropTypes.any,
  day: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    calendars: state.calendarReducer.get('calendars'),
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getCalendar: (sportId, competitionId, widgetId) =>
        dispatch({
          type: types.GET_CALENDAR_REQUEST,
          sportId,
          competitionId,
          widgetId,
        }),
      getDayCalendar: (sportId, competitionId, widgetId, day) =>
        dispatch({
          type: types.GET_DAY_CALENDAR_REQUEST,
          sportId,
          competitionId,
          widgetId,
          day,
        }),
    },
  }),
)(DayWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/DayWidgetGazzanet/index.js